import React from 'react';
// import { useNavigate } from 'react-router-dom'; // Auskommentiert: spätere Reaktivierung möglich
import styles from './ProjectCard.module.css';

const ProjectCard = ({ project }) => {
  // const navigate = useNavigate(); // Auskommentiert
  // const handleClick = () => { // Auskommentiert
  //   navigate(`/project/${project.id}`);
  // };

  const cardInner = (
    <div className="row g-0 w-100">
      <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-start">
        <div className={styles.contentSection}>
          <h2 className={`fw-bold mb-2 ${styles.title}`}>{project.name}</h2>
          <p className={`mt-3 ${styles.description}`}>{project.description}</p>
          <div className="mt-2 mb-2">
            {project.technologies && project.technologies.map((tech, idx) => (
              <span key={idx} className={`badge me-2 ${styles.techSpecs}`}>{tech}</span>
            ))}
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
        <img
          src={project.imageUrl}
          alt={project.name + ' Preview'}
          className={`${styles.projectPreviewImage}`}
        />
      </div>
    </div>
  );

  if (project.link) {
    return (
      <a
        href={project.link}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.projectCard}
        style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
      >
        {cardInner}
      </a>
    );
  }

  return (
    <>
      {/* To re-enable navigation later: add onClick={handleClick} and set cursor to 'pointer' */}
      <div
        className={`${styles.projectCard}`}
        style={{ cursor: 'default' }}
        // onClick={handleClick}
      >
        {cardInner}
      </div>
    </>
  );
};

export default ProjectCard; 